module.exports = __webpack_public_path__ + "static/media/section1-image2.adbb2642.webp";